const SAFE_EXPR = /^[\d\s+\-*/.()]+$/;

function maxDecimals(expr) {
  const nums = expr.match(/\d+\.\d+/g) || [];
  return nums.reduce((max, n) => Math.max(max, n.split(".")[1].length), 0);
}

function compute(expr) {
  if (!expr || !SAFE_EXPR.test(expr)) return null;
  try {
    // eslint-disable-next-line no-new-func
    const result = new Function("return (" + expr + ")")();
    if (typeof result !== "number" || !isFinite(result)) return null;
    if (Number.isInteger(result)) return String(result);
    const decimals = maxDecimals(expr);
    const precision = decimals === 0 ? 6 : decimals;
    return String(parseFloat(result.toFixed(precision)));
  } catch {
    return null;
  }
}

// For text inputs: value must start with "="
export function evaluateMathExpr(raw) {
  if (typeof raw !== "string" || !raw.startsWith("=")) return null;
  return compute(raw.slice(1).trim());
}

// For number inputs: value is evaluated directly (no "=" needed)
export function evaluateNumberExpr(raw) {
  if (typeof raw !== "string") return null;
  return compute(raw.trim());
}

// True when the value contains math operators beyond a plain number / negative
export function isMathExpression(val) {
  if (!val) return false;
  return /[*/()]/.test(val) || /[+-]/.test(val.slice(1));
}
